import React from "react";
import {observer} from "mobx-react-lite";
import {TextObservable} from "../../../stores/observables/textObservable";
import "../input/input.sass";
import ButtonIcon from "../button/buttonIcon";
import Icon from "../common/icon/icon";
import {IconSource} from "../../../shared/enums/iconSource";
import {useTranslation} from "react-i18next";
import {Input} from "reactstrap";

export enum SearchBoxType {
  Live = "live",
  NonLive = "non-live"
}

export interface ISearchBoxProps {
  hasPrefixIcon?: boolean;
  showSearchIcon?: boolean;
  value: TextObservable;
  type: SearchBoxType;
  placeholder?: string;
  onClick?: () => void;
  onClear?: () => void;
}

const SearchBox: React.FC<ISearchBoxProps> = ({
  value,
  placeholder,
  type,
  onClick,
  onClear,
  hasPrefixIcon = true,
  showSearchIcon = false
}) => {
  const {t} = useTranslation("translation");

  function handleClear() {
    value.setText("");
    onClear?.();
  }

  function handleTextChange(event: React.ChangeEvent<HTMLInputElement>) {
    value.setText(event.target.value);
  }

  function handleKeyUp(event: React.KeyboardEvent<HTMLInputElement>) {
    if (event.key === "Enter") {
      onClick?.();
    }
  }

  return (
    <div className="input-box search-box">
      {hasPrefixIcon && (
        <span>
          <Icon source={IconSource.search}></Icon>
        </span>
      )}
      <Input
        type="text"
        inputMode="text"
        value={value.text ?? ""}
        onChange={handleTextChange}
        onKeyUp={handleKeyUp}
        placeholder={placeholder}
        className={type.toString()}
      />
      <div>
        {value.text && (
          <Icon source={IconSource.exit} onClick={handleClear}></Icon>
        )}
        {type === SearchBoxType.NonLive && (
          <ButtonIcon
            icon={showSearchIcon ? IconSource.search : undefined}
            type={"accessory"}
            onClick={onClick}
          >
            {!showSearchIcon && t("translation:actions.search")}
          </ButtonIcon>
        )}
      </div>
    </div>
  );
};

export default observer(SearchBox);
